export const FAIXAS_DEFAULT = [
  {
    dias: 7,
    label: "Até 7 dias",
    mensagem: "Oi, {nome_cliente}! 😊\n\nPassamos só para dizer que estamos com saudades de {nome_pet}! 🐾🧡",
  },
  {
    dias: 15,
    label: "Até 15 dias",
    mensagem: "Oi, {nome_cliente}! 😊\n\nTemos uma dúvida muito importante por aqui...\n\nCadê {nome_pet}? 🐾🧡\n\nJá estamos com saudades dessa fofura!",
  },
  {
    dias: 30,
    label: "Até 30 dias",
    mensagem: "Oi, {nome_cliente}! 🧡\n\nA equipe comentou esses dias: \"Cadê {nome_pet}?\" 🐾😊\n\nEstamos sentindo falta dessa carinha linda por aqui!",
  },
  {
    dias: 45,
    label: "Até 45 dias",
    mensagem: "Olá, {nome_cliente}! 😊\n\nPassamos para saber como está {nome_pet}. 🐾🧡\n\nSerá um prazer receber essa fofura novamente por aqui!",
  },
  {
    dias: null,
    label: "Mais de 45 dias",
    mensagem: "Oi, {nome_cliente}! 🧡\n\nEsperamos que esteja tudo bem com vocês!\n\nPassamos para deixar um carinho para {nome_pet} e dizer que estamos com saudades. 🐾😊",
  },
];
